export default __webpack_public_path__ + "static/media/logout.f0846573.svg";